import { useQuery } from '@tanstack/react-query';
import useAcquireToken from '../../AuthToken/Hooks/useAcquireToken';
import useBSTInsightsAPI from '../../../apiclients/api/bstinsightsapi';
import { UserExistingRolesRequestDTO } from '../../../apiclients/bstinsights';
import { GRID_DATA_QUERY_PREFIX } from './utils/constants';

export const useGetExistingRoles = (payload: UserExistingRolesRequestDTO) => {
  const { getUsersGetExistingRolesCount } = useBSTInsightsAPI();
  const { getTokenSilently } = useAcquireToken();
  return useQuery({
    queryKey: [GRID_DATA_QUERY_PREFIX, payload],
    queryFn: async () => {
      const token = await getTokenSilently();
      if (!token) return;
      return await getUsersGetExistingRolesCount(token, payload);
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });
}
